import { render, staticRenderFns } from "./AppealBlock.vue?vue&type=template&id=2a2d7a52&scoped=true&"
import script from "./AppealBlock.vue?vue&type=script&lang=js&"
export * from "./AppealBlock.vue?vue&type=script&lang=js&"
import style0 from "./AppealBlock.vue?vue&type=style&index=0&id=2a2d7a52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d7a52",
  null
  
)

export default component.exports